import { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";

import type { SingleReviewBlock as SingleReviewBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { StarRating } from "../StarRating";

import styles from "./index.module.scss";

type IProps = Immutable<{ value: SingleReviewBlockValue }>;

export const CocoonSingleReviewBlock = (props: IProps): React.JSX.Element => {
    return (
        <div
            className={concatClassNames([
                styles.singleReviewBlock,
                getGlobalSpacingClasses(props.value.spacing),
            ])}
        >
            <div className={styles.singleReviewBlockHeader}>
                {props.value.title}
            </div>
            <StarRating
                rating={props.value.stars}
                inverted
                className={styles.singleReviewBlockStarRatingContainer}
            />
            <div className={styles.singleReviewBlockCopy}>
                &quot;{props.value.review}&quot;
            </div>
            <div className={styles.singleReviewBlockAuthor}>
                {props.value.author}
            </div>
            <div className={styles.singleReviewBlockCity}>
                {props.value.city}, {props.value.state}
            </div>
        </div>
    );
};
